import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import QRCode from "common/components/QRCode";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import CropFree from "@mui/icons-material/FilterCenterFocus";

const styles = (theme) => ({
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
});

class QRCodeModal extends Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, content } = this.props;

    return (
      <Fragment>
        <Button onClick={this.handleOpen} variant="contained">
          <CropFree className={classes.buttonIcon} />
          QR Code
        </Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          maxWidth={false}
        >
          <DialogTitle>Redemption QR Code</DialogTitle>
          <DialogContent>
            <DialogContentText>{content}</DialogContentText>
            <QRCode content={content} />
          </DialogContent>
        </Dialog>
      </Fragment>
    );
  }
}

QRCodeModal.propTypes = {
  classes: PropTypes.object.isRequired,
  content: PropTypes.string,
};

export default withStyles(styles)(QRCodeModal);
